module.exports = __webpack_public_path__ + "img/1-6.fb04af6f.png";